import { ServiceOfferItem } from '../../../../model';

export const HIDE_FILTERS = ['offerGroup'];
export const IGNORE_FILTERS = ['isTeliaOne', 'contractDuration'];

export const FACET_QUERY_KEY_MAP = {
    dataSizeDomesticTotal: 'plans.plans_list.filters.search_param.data_size_domestic',
    dataSizeEuropeTotal: 'plans.plans_list.filters.search_param.data_size_europe',
    price: 'plans.plans_list.filters.search_param.price',
    connectionTechnology: 'plans.plans_list.filters.search_param.connection_technology',
    benefitNames: 'plans.plans_list.filters.search_param.benefit_names',
} satisfies Partial<{ [key in keyof ServiceOfferItem]: string }>;
